import { PropsWithChildren } from 'react';

type MenuProps = PropsWithChildren;

export const Menu = ({ children }: MenuProps)=> {
    return (
        <nav
            className={'fixed bottom-0 left-0 z-40 h-20 w-full bg-surface-1 p-2 md:h-screen md:w-24 md:bg-background md:py-4 lg:w-60 lg:px-4 lg:py-8'}>
            <div
                className={'flex h-full w-full flex-row justify-around gap-4 md:flex-col md:items-center md:justify-start lg:gap-2'}>
                {children}
            </div>
        </nav>
    );
}
